<template>
    <modal @close="close" dialog="modal-lg" class="fluid dark-top danger">
        <div slot="title">
            <view-header title="Cancel reservation" icon="alert"></view-header>
        </div>

        <div slot="body" class="d-flex">
            <div class="p-4 col-5 sidebar">
                <h5 class="bold mb-3">Payment history</h5>

                <table class="table">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Paid with</th>
                            <th class="text-right">Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="payment in payments" class="bg-lighter">
                            <td>
                                {{ payment.date | moment('YYYY-MM-DD') }}
                                <div class="dark fs-smaller">{{ payment.date | moment('HH:mm') }}</div>
                            </td>
                            <td>
                                {{ payment.type }}
                            </td>
                            <td class="text-right">
                                {{ payment.value }}{{ payment.currency }}
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colspan="3" class="fs-normal bold bg-lighter text-right">
                                Total paid: {{ total.toFixed(2) }}&euro;
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>

            <div class="col-7 p-4 main">
                <h5 class="bold mb-2">Select payment details</h5>
                <div class="fs-small">
                    By cancelling this reservation you are creating a credit note. This can not be undone.
                </div>

                <cancellation-methods
                    @validateRefunds="validateRefunds"
                    @updateRefunds="updateRefunds">
                </cancellation-methods>

                <label>Description</label>
                <textarea class="full" placeholder="" v-model="reservation.billing.description"></textarea>
            </div>
        </div>

        <div slot="footer">
            <button type="button" class="btn tertiary wider" @click="close">Cancel</button>
            <button type="button" class="btn blue wider" @click="reschedule">No, reschedule</button>
            <button type="button" class="btn action wider" :disabled="disabled" @click="erase">Yes, I'm sure</button>
        </div>
    </modal>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import { reservationsMixin } from '@/mixins/reservations'
    import Modal from './Modal'
    import CancellationMethods from '@/components/reservations/CancellationMethods'
    import ViewHeader from '@/components/reservations/view/ViewHeader'

    export default {
        mixins: [reservationsMixin],
        data: function () {
            return {
                reservation: {},
                disabled: false, // No validation for now
            }
        },
        created: function() {
            if (this.getSelectedReservation) {
                this.reservation = JSON.parse(JSON.stringify(this.getSelectedReservation));
            }
        },
        computed: {
            ...mapGetters([
                'getSelectedReservation',
                'account',
            ]),
            total: function() {
                var total = 0;

                this.payments.forEach((p) => {
                    total += parseFloat(p.value);
                });

                return total;
            },
            payments: function() {
                return this.reservation.payments;
            }
        },
        methods: {
            ...mapActions([
                'resetNewReservationSetup',
                'cancelReservation',
                'clearActiveReservation',
                'openModal'
            ]),
            updateRefunds: function(fields) {
                Object.keys(fields).forEach((key) => {
                    this.$set(this.reservation.billing, 'refunds', fields);
                });

                console.log('Updated refunds with', this.reservation);
            },
            erase: function() {
                this.cancelReservation({
                    action: 'cancel',
                    fields: { supplierId: this.account.supplierId, reservation: this.reservation }
                });
            },
            close: function() {
                this.clearActiveReservation();
            },
            reschedule: function() {
                this.resetNewReservationSetup().then(() => {
                    this.openModal('ReservationAdd');
                });
            },
            validateRefunds: function(invalid) {
                this.disabled = invalid;
            },
        },
        components: {
            Modal,
            ViewHeader,
            CancellationMethods,
        }
    }
</script>


// WEBPACK FOOTER //
// ReservationCancel.vue?3b66d50b